import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { TextInput } from "../../../components/textInput/textInput";
import { CopyIcon, FindItemIcon } from "../../../assets/icons";
import { useEffect, useState } from "react";
import { WorkerItem } from "./workerItem";
import { Button } from "../../../components/button/button";
import { useParams } from "react-router";
import { PageLoader } from "../../../components/loader/pageLoader";
import { usePopup } from "../../../components/popup/popup";
import { copyToClipboard } from "../../../utils/copyToClipboard";
import { Separator } from "../../../components/separator/separator";
import AdminAPI from "../../../api/AdminAPI";

import { Text } from "../../../components/text/text";

import styles from "./workersList.module.css"

export const WorkersList = () => {
    const [employees, setEmployees] = useState([]);
    const [search, setSearch] = useState("");

    const [workersLoading, setWorkersLoading] = useState(false);
    const { cafeId } = useParams();
    useEffect(() => {
        if (cafeId === null) return;
        setWorkersLoading(true);
        AdminAPI
            .fetchCafeEmployees(cafeId)
            .then(res => setEmployees(res))
            .catch(console.error)
            .finally(() => setWorkersLoading(false));
    }, [cafeId]);

    const [inviteLink, setInviteLink] = useState("");
    const [Popup, open, close] = usePopup();
    const onOpenInvite = () => {
        AdminAPI
            .fetchInviteLink(cafeId)
            .then(res => {
                setInviteLink(res.inviteLink);
                open();
            })
            .catch(console.error);
    }

    return (
        <>
            <AdminHeader title="Ваши сотрудники" />
            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

            {
                workersLoading &&
                <PageLoader />
            }

            {
                !workersLoading &&
                <div className={styles.employees_buttons}>
                    {
                        employees.filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                            <WorkerItem key={data.userId} data={data} />
                        )
                    }
                </div>
            }

            <Separator />

            <Button
                fixed
                text={"Пригласить сотрудника"}
                icon={<CopyIcon />}
                onClick={onOpenInvite}
            />

            <Popup>
                <Text as="div" variant="h3" className={styles.copy_title} >Пригласить сотрудника</Text>
                <div className={styles.copy_block}>
                    <TextInput value={inviteLink} setValue={() => {}}/>
                    <Button
                        type="hint"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(inviteLink)}
                    />
                </div>
                <Button
                    text="Закрыть"
                    onClick={close}
                />
            </Popup>
        </>
    )
}
